import React, { useEffect, useMemo, useState } from 'react';
import Layout from '../components/Layout';
import GeneralBetsList from '../components/GeneralBetsList';
import { getUsers, User } from '../api/usersApi';

const UsersGeneralBetsPage: React.FC = () => {
  const [users, setUsers] = useState<User[]>([]);
  const [selectedUserId, setSelectedUserId] = useState<number | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      setError('');
      try {
        const data = await getUsers();
        setUsers(data);
        if (data.length > 0) {
          setSelectedUserId(data[0].id);
        }
      } catch (err) {
        console.error('Error fetching users for general bets view:', err);
        setError('Failed to load users. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const handleChangeUser = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const val = e.target.value;
    setSelectedUserId(val ? Number(val) : null);
  };

  const selectedUser = useMemo(
    () => users.find((u) => u.id === selectedUserId) || null,
    [users, selectedUserId]
  );

  return (
    <Layout>
      <div className="container mx-auto py-6">
        <h1 className="text-2xl font-bold text-white mb-6">כלליים של כולם</h1>

        {loading ? (
          <div className="flex justify-center items-center h-40 text-gray-400">
            טוען משתמשים...
          </div>
        ) : error ? (
          <div className="bg-red-500 text-white p-4 rounded-md mb-4">
            {error}
          </div>
        ) : (
          <>
            <div className="mb-6 flex flex-col sm:flex-row sm:items-center gap-4">
              <label className="text-gray-300 font-medium">בחר משתמש:</label>
              <select
                className="bg-gray-800 border border-gray-700 text-white rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 min-w-[220px]"
                value={selectedUserId ?? ''}
                onChange={handleChangeUser}
              >
                {users.map((user) => (
                  <option key={user.id} value={user.id}>
                    {user.first_name} {user.last_name}
                  </option>
                ))}
              </select>
            </div>

            {selectedUserId ? (
              <GeneralBetsList userId={selectedUserId} />
            ) : (
              <div className="text-gray-400">אין משתמש נבחר.</div>
            )}
          </>
        )}
      </div>
    </Layout>
  );
};

export default UsersGeneralBetsPage;


